import { RG_TYPE as t } from "@project-rouge/rg-core";
import { getBoundaryOfObjects as o } from "./index4.js";
function m(a, f, r) {
  r ?? (r = [t.Module, t.Entrance, t.Apartment, t.Core, t.Corridor, t.TechnicalSpace]);
  const i = a.children.filter((e) => f.includes(e.data.level));
  if (i.length === 0)
    return [];
  const n = i.filter((e) => r == null ? void 0 : r.includes(e.type));
  return n.length === 0 ? [] : o(n, r);
}
export {
  m as getBuildingBoundary
};
//# sourceMappingURL=index5.js.map
